<style lang="less" scoped>
ul li {
  list-style: none;
}
.clear {
  clear: both;
}
.group {
  height: 120px;
  background: #fff;
  padding: 20px;
  .groupName {
    height: 40px;
    line-height: 40px;
    color: #040506;
    font-size: 16px;
  }
  /deep/.ant-input {
    height: 40px;
    line-height: 40px;
    background: #f6f6f6;
  }
}
.newGroupInfo {
  margin-top: 20px;
  height: 100px;
  .groupMess {
    min-height: 120px;
    background: #fff;
    padding: 20px;
    .groupTitle {
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      color: #040506;
      .left {
        text-align: left;
      }
      .right {
        text-align: right;
        .cancel {
          margin-right: 10px;
        }
      }
    }
    .add {
      color: @primary-color;
      cursor: pointer;
      .addStu {
        color: @primary-color;
        margin-left: 10px;
      }
    }
    /deep/.ant-checkbox-group {
      width: 100%;
    }
  }

  .userImg {
    margin-left: 10px;
    margin-top: -5px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
  .userName {
    // margin-left: 10px;
    height: 30px;
    line-height: 30px;
  }
  .footer {
    height: 60px;
    line-height: 60px;
  }
  /deep/.ant-layout-content > div {
    padding: 0px;
  }
  .saveMess {
    text-align: center;
    height: 50px;
    line-height: 50px;
  }
}
.studentList {
  .col {
    margin-top: 10px;
    .userImg {
      height: 30px;
      width: 30px;
      border-radius: 50%;
    }
    .userName {
      margin-left: 10px;
    }
  }
}
</style>
<template>
  <div style="background:#f6f6f6;">
    <div class="group">
      <div class="groupName">群聊名称</div>
      <a-input placeholder="请输入群聊名称"
               @change="textChange" />
    </div>
    <div class="newGroupInfo">
      <div class="groupMess">
        <a-row class="groupTitle">
          <a-col :span="12" class="left">
            <span>成员</span>
          </a-col>
          <a-col :span="12" class="right">
            <!-- <a-button v-if="!xzc" type="warn" group="cancel" @click="xzcCancel">取消</a-button> -->
            <a-button v-if="!xzc"
                      type="primary"
                      class="sure"
                      @click="xzcSure">确定</a-button>
            <a-button v-if="xzc"
                      type="primary"
                      class="select"
                      @click="selectLeader">选组长</a-button>
          </a-col>
        </a-row>
        <a-radio-group @change="onChangeLeader">
          <a-row>
            <a-col :span="8"
                   v-for="(item,index) in newAddList"
                   :key="index">
              <div style="width:325px;">
                <a-radio :value="item"
                         :disabled="xzc">
                  <template>
                    <img class="userImg"
                         v-if="item.photo!=null"
                         :src="resbaseUrl+item.photo"
                         alt="">
                    <img class="userImg"
                         v-if="item.photo==null"
                         src="/imgs/stu-photo.png"
                         alt="" />
                    <span class="userName">{{item.userName}}</span>
                    <a-button v-show="item.isGroupLeader==1" style="margin-left: 10px">组长</a-button>
                    <a-icon v-if="xzc"
                            @click="delStu(item)"
                            style="color:red;margin-left:10px;"
                            type="user-delete" />
                  </template>
                </a-radio>
              </div>
            </a-col>
          </a-row>
        </a-radio-group>
        <div class="add"
             @click="addStudent">
          <a-icon class="addIcon"
                  type="plus-circle" />
          <span class="addStu">添加学生</span>
        </div>
      </div>
      <div class="saveMess">
        <a-button type="primary"
                  @click="saveGroup">保存小组</a-button>
      </div>
    </div>
    <a-modal title="选择学生"
             width='1000px'
             footer=""
             :visible="addStuModel"
             @cancel="handleCancel"
             destroyOnClose>
      <div class="studentList"
           style="min-height:120px;max-height:300px;overflow-y:scroll;">
        <a-checkbox-group style="width:100%;"
                          v-model="checkedList"
                          :options="plainOptions.id"
                          @change="onChange">
          <a-row>
            <a-col class="col"
                   :span="8"
                   v-for="(item,index) in students"
                   :key="index">
              <a-checkbox :value="item">
                <template>
                  <img class="userImg" v-if="item.photo!=null" :src="resbaseUrl+item.photo" alt="">
                  <img class="userImg" v-if="item.photo==null" src="imgs/stu-photo.png" alt="" />
                  <span class="userName">{{item.userName}}</span>
                </template>
              </a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
      <div class="footer">
        <a-checkbox class="allSelect"
                    :indeterminate="indeterminate"
                    :checked="checkAll"
                    @change="onCheckAllChange">全选</a-checkbox>
        <span style="color: #9d9292;font-size:20px;margin-left:20px;">已选择{{this.checkedList.length}}个</span>
        <a-button type="primary"
                  style="float:right;"
                  @click="sureFun">确定</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'AppointGroup',
  data () {
    return {
      resbaseUrl: this.$resBasePath + '/',
      addStuModel: false,
      xzc: true,// 选组长
      checkAll: false,//全选
      indeterminate: true,//动画
      checkedList: [],//选择列表
      plainOptions: [],
      studentsList: [],//待选取学生的列表
      newAddList: [],//选择完待处理的学生列表
      classId: '', //班级ID
      groupid: '',//路由传过来的参数
      groups: [], //分组后的小组列表
      groupUuid: '',
      groupName: '',//小组名称
      students: [], //学生人员
      studentsLeader: [] //选取组长
    }
  },
  watch: {
    $route () {
      this.groupid = this.$route.params.groupid
    },
    newAddList: function () {

    }
  },
  beforeMount () {

  },
  mounted () {
    // this.groupid = this.$route.params.groupid
    // const info = JSON.parse(localStorage.getItem('newClassInfo')).filter(c=>c.groupTag === this.groupid)[0]
    // this.classId = info.id
    // this.stuNum = info.studentCount
    this.getClassData()
  },
  methods: {
    textChange (e) { //小组群名称
      this.groupName = e.target.value
    },
    onChange (checkedList) { //选择学生
      // this.studentsList = checkedList
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length
      this.checkAll = checkedList.length === this.plainOptions.length
    },
    onChangeLeader (e) { // 选组长
      //debugger
      this.studentsLeader.push(e.target.value)
      this.newAddList.forEach(item => {
        if (item.id == this.studentsLeader[0].id) {
          item.isGroupLeader = 1
        } else {
          item.isGroupLeader = 0
        }
      })
    },
    onCheckAllChange (e) { // 全选
      Object.assign(this, {
        checkedList: e.target.checked ? this.plainOptions : [],
        indeterminate: false,
        checkAll: e.target.checked,
      })
      //console.log(this.checkedList)
    },
    getClassData () { //获取班级成员信息
      // let _this = this
      // this.$fetch({
      //   url: _this.$baseUrl + 'ebook/group/common/getClassInfoById',
      //   body: { id: localStorage.getItem('classID') }
      // }).done(res => {
      //   if (res && res.success && res.resultCode === 0) {
      //     _this.stuNum = res.resultData.studentCount
      //     _this.students = res.resultData.students
      //     _this.plainOptions = res.resultData.students
      //   }
      // })
      // 根据班级id 获取班级学生列表
      const _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/class/common/v2/getV2MyClassStu',
        body: { classId: localStorage.getItem('classID') }
      })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            const stu = res.resultData.filter((msg) => msg.isTea === 0)
            _this.stuNum = stu.length
            _this.students = stu
            _this.plainOptions = stu
            console.log('getV2MyClassStu')
            console.log(res)
          }
        })
    },
    addStudent () { // 添加学生弹窗
      this.addStuModel = true
      // this.newAddList = []
    },
    selectLeader () { // 选组长
      this.studentsLeader = []
      this.xzc = false
    },
    sureFun () { // 添加学生后的确定
      this.newAddList = this.checkedList
      for (let i = 0; i < this.newAddList.length; i++) {
        const ele = this.newAddList[i];
        ele['isGroupLeader'] = 0
      }
      if (this.newAddList.length > 0) this.addStuModel = false
      const param = {
        userId: '',
        classId: '',
        groupName: '',
        students: []
      }
    },
    delStu (item) { // 删除某个成员
      this.newAddList = this.newAddList.filter(obj => obj.id !== item.id)
      //console.log(this.newAddList);
    },
    xzcSure () { //选组长确定
      if (this.studentsLeader.length !== 1) this.$message.warning('请您选择一个组长')
      this.xzc = true
    },
    xzcCancel () {
      this.xzc = true
      if (this.studentsLeader.length !== 1) this.$message.warning('您还没有选择组长')
      this.studentsLeader = []
    },
    handleCancel (e) {
      this.addStuModel = false
      this.checkedList = []
    },
    saveGroup () {
      if (this.studentsLeader.length !== 1) {
        this.$message.warning('请您选择一个组长')
        return
      }
      if (!this.groupName || this.groupName == '') {
        this.$message.warning('请您输入小组名称')
        return
      }
      if(this.groupName.length>8){
        this.$message.warning('请您输入小组名称在8个汉字以内')
        return
      }
      const arr = []
      this.newAddList.forEach(item => {
        arr.push({
          userId: item.id,
          isGroupLeader: item.isGroupLeader
        })
      })
      const param = {
        userId: this.$getUserInfo().id,
        classId: localStorage.getItem('classID'),
        groupName: this.groupName,
        students: arr
      }
      let _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/class/common/chooseStudentSetGroup',
        body: param
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          _this.$message.success('新建小组成功')
          _this.$router.push({ name: 'AccompanyStudy' })
        }
      })
    }
  }
}
</script>
